/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Vang Pham (ptvang@rsupport.com)
 *
 * @description
 *
 * @created at Fri Aug 9 2024
 **/

import styled from "@emotion/styled";
import { css } from "@emotion/react";

import { CircularProgress } from "@mui/material";

import { _T } from "@rfice/language";
import { Row, Typography, Button } from "@/frameworks/designStuff/components";

type PopupDownloadProps = {
	onClick: () => void;
};

export default function PopupDownload({ onClick }: PopupDownloadProps) {
	const closePopup = (ev: React.MouseEvent<HTMLButtonElement>) => {
		ev.stopPropagation();
		onClick();
	};

	return (
		<PopupDownloadWrapper onClick={(e) => e.stopPropagation()}>
			<div css={borderRight}></div>
			<Row gap={6} verticalAlign="center" css={{ width: "100%" }}>
				<CircularProgress size={18} color="inherit" />
				<Typography css={{ flexGrow: 1, textAlign: "left" }}> {_T("파일이 다운로드 됩니다.")}</Typography>
				<Button.Icon
					name="Close24"
					size="medium"
					filled="transparent"
					fill="neutral_80_100"
					onClick={closePopup}
				/>
			</Row>
		</PopupDownloadWrapper>
	);
}

const PopupDownloadWrapper = styled(Row)`
	background: #f1ffed;
	border: 1px solid #1b1b1b;
	min-width: 274px;
	border-radius: 4px;
	padding: 8px 10px;
	overflow: hidden;
`;

const borderRight = css`
	border-radius: 4px 0px 0px 4px;
	background: #9edd8c;
	position: absolute;
	width: 6px;
	bottom: 0;
	top: 0;
	left: 1px;
`;
